import * as styles from "./AssignRecordsView.style.ts";
import {
  TransferList,
  type TransferListGridRow,
  type TransferListProps,
} from "src/components/TransferList/TransferList.tsx";

export const AssignRecordsView = <
  Row extends TransferListGridRow = TransferListGridRow,
>({
  onClose,
  ...rest
}: {
  onClose?: () => void;
} & TransferListProps<Row>) => {
  return (
    <div css={styles.root}>
      <TransferList css={styles.transferList} {...rest} />
    </div>
  );
};
